// Base64ImageComponent.jsx
import React from 'react';
import PropTypes from 'prop-types';

const Base64ImageComponent = ({ base64, imageType = 'png', alt = 'Base64 Image' }) => {
  // Ensure the Base64 string has the correct prefix
  const src = `data:image/${imageType};base64,${base64}`;

  return (
    <div>
      <img src={src} alt={alt} style={{ maxWidth: '100%', height: 'auto' }} />
    </div>
  );
};

Base64ImageComponent.propTypes = {
  base64: PropTypes.string.isRequired,
  imageType: PropTypes.string,
  alt: PropTypes.string,
};

export default Base64ImageComponent;
